export default __webpack_public_path__ + "static/media/babyClothes.5c907c5c.svg";